var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":_vm.page,"frameborder":"0"},on:{"load":function($event){return _vm.iframeLoaded()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }